import { render } from "./ReviewPeriodCell.vue?vue&type=template&id=988e9da8&scoped=true"
import script from "./ReviewPeriodCell.vue?vue&type=script&lang=js"
export * from "./ReviewPeriodCell.vue?vue&type=script&lang=js"

import "./ReviewPeriodCell.vue?vue&type=style&index=0&id=988e9da8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988e9da8"]])

export default __exports__